<template>
  <div>
    <link rel="stylesheet" href="https://unpkg.com/swiper/swiper-bundle.min.css">
    <header-for-landing ref="headerRef"/>
    <router-view></router-view>
    <footer-for-landing></footer-for-landing>
    <popup-for-landing
        :show="isShowLoginPopup"
        @close="$store.dispatch('SET_IS_SHOW_LOGIN_POPUP', false)">
      <template #contents>
        <div class="txt01">로그인 후 서비스 신청 가능합니다.</div>
        <div class="txt02">로그인페이지로 이동합니다.<br>
          비회원이신경우는 회원가입을 진행해주세요.</div>
        <div class="btn_flex">
          <button @click="$store.dispatch('SET_IS_SHOW_LOGIN_POPUP', false)"
                  class="k-button k-button-icon">닫기
          </button>
          <button @click="goLogin" class="k-button k-button-icon">
            바로가기
          </button>
        </div>
      </template>
    </popup-for-landing>
  </div>
</template>
<script>
import HeaderForLanding from '@/landing/components/HeaderForLanding.vue'
import Pricing from '@/landing/view/Pricing'
import FooterForLanding from '@/landing/components/FooterForLanding'
import PopupForLanding from '@/landing/components/PopupForLanding.vue'

export default {
  name: 'LandingLayout',
  components : {
    HeaderForLanding,
    Pricing,
    PopupForLanding,
    FooterForLanding
  },
  computed : {
    isShowLoginPopup: function () {
      return this.$store.getters['isShowLoginPopup']
    },
  },
  created () {
    if(!!this.$store.getters.loginUserToken) this.$store.dispatch('initSearchDataForCodeRequest')
  },
  methods : {
    goLogin : function (){
      this.$store.dispatch('SET_IS_SHOW_LOGIN_POPUP', false)
      window.location.href = '/login'
    },
  },
}
</script>
<style lang="css">
@import "../../assets/css/jquery.fullPage.css";
@import "../../assets/css/flexslider.css";
@import "../../assets/css/style.css";
@import "../../assets/css/animate.css";
</style>
